import ApplicationView from './ApplicationView';

export default class CollapsibleContainer extends ApplicationView 
{
  constructor(name, container, enabled = false) 
{
    super(name, container);

    this.view_enabled = enabled;
    this.header = this.__configure_header(this.container);

    this.online_icon_el = this.container.find('.menu__collapsable-container__header-online-icon');
    this.online_icon_circle_el = this.online_icon_el.find('.lightning');
    this.body_container_el = this.container.find('.menu__collapsable-container__body-container');
    this.body_el = this.container.find('.menu__collapsable-container__body');
    this.body_status_el = this.container.find('.menu__collapsable-container__body-status')[0];
    this.arrow_el = this.container.find('.menu__collapsable-container__header-arrow');

    // If body_status element not defined then hide header rec item
    if (!this.body_status_el) 
{
      this.online_icon_el.addClass('hidden');
    }

    this.status_label_prefix = ' Online: ';
    this.set_offline(`${this.name} backend is OFFLINE`);

    // Close (collapse) by default
    this.close();

    if (enabled) 
{
      this.show();
    }
 else 
{
      this.hide();
    }
  }

  start() 
{
    this.initialized = true;
  }

  show() 
{
    super.show();
    this.container.removeClass('hidden');
  }

  hide() 
{
    super.hide();
    this.container.addClass('hidden');
  }

  open() 
{
    this.body_container_el.removeClass('hidden');
    this.arrow_el.addClass('expanded');
  }

  close() 
{
    this.body_container_el.addClass('hidden');
    this.arrow_el.removeClass('expanded');
  }

  set_status_label_prefix(text) 
{
    this.status_label_prefix = text;
  }

  set_online(text) 
{
    this.online = true;
    if (this.online_icon_circle_el) this.online_icon_circle_el.css('fill', '#00FF00');

    if (this.body_status_el) 
{
      this.body_status_el.innerHTML = ` ${this.status_label_prefix}<span class="collapsable-container__positive-color">${text || 'Yes'}</span>`;
    }
    this.body_el.removeClass('hidden');
  }

  set_offline(text) 
{
    this.online = false;
    if (this.online_icon_circle_el) this.online_icon_circle_el.css('fill', '#FF0000');
    if (this.body_status_el) 
{
      this.body_status_el.innerHTML = ` ${this.status_label_prefix}<span class="collapsable-container__negative-color">${text || 'No'}</span>`;
    }
    this.body_el.addClass('hidden');
  }

  set_body_status() 
{

  }

  __configure_header(container) 
{
    const header = container.find('.menu__collapsable-container__header')[0];

    if (!header) 
{
      console.error(`Container with id "${header}" not found.`);
      return null;
    }

    header.addEventListener('click', () => 
{
      if (this.body_container_el.hasClass('hidden')) 
{
        this.open();
      }
 else 
{
        this.close();
      }
    });

    return header;
  }
}
